/**
 * pages/societybook/index.jsx — v3
 * CHANGES:
 *   - Renamed "Billing" tab to "Billing & Payments"
 */
import React, { useState } from 'react';
import SBDashboard from './SBDashboard';
import MembersTab  from './MembersTab';
import BillingTab  from './BillingTab';
import SBSettings  from './SBSettings';

const TABS = [
  { key: 'dashboard', label: 'Dashboard'         },
  { key: 'members',   label: 'Members'            },
  { key: 'billing',   label: 'Billing & Payments' },
  { key: 'settings',  label: 'Settings'           },
];

export default function SocietyBook({ societyId, activeFY }) {
  const [tab, setTab] = useState('dashboard');

  return (
    <div>
      <div className="sb-subtabs" style={{ marginBottom: '1.5rem' }}>
        {TABS.map(t => (
          <button key={t.key}
            className={`sb-subtab ${tab === t.key ? 'active' : ''}`}
            onClick={() => setTab(t.key)}>
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'dashboard' && <SBDashboard societyId={societyId} />}
      {tab === 'members'   && <MembersTab  societyId={societyId} />}
      {tab === 'billing'   && <BillingTab  societyId={societyId} activeFY={activeFY} />}
      {tab === 'settings'  && <SBSettings  societyId={societyId} />}
    </div>
  );
}
